// extracted by mini-css-extract-plugin
module.exports = {"button":"SectionSelector-button-4145d11e628ab5a84c404b49ccbf41bb","buttonText":"SectionSelector-buttonText-fc09be073fe9a41854872baa09e92243"};